<template>
  <div class="bg-green flex-0-0">
    <div class="container p-y-1 p-y-2:t p-x-1:mo d-flex jc-between ai-center">
      <div class="m-r-3 c-white">
        <span class="d-none:t">{{ warning.extra_info.short_text }}</span>
        <span class="d-none:mo">{{ warning.message }}</span>
      </div>
      <button class="btn-ghostfilled flex-0-0" @click="$emit('cta-clicked', warning)">
        <span class="d-none:t">{{ warning.extra_info.short_cta }}</span>
        <span class="d-none:mo">{{ warning.extra_info.full_cta }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'warning-banner-item',
  components: {},
  props: {
    warning: {
      type: Object,
      required: true,
    },
  },
};
</script>
